// Angular modules.
import { Injectable } from '@angular/core';
// Third-party modules.
import { TranslateService } from '@ngx-translate/core';
// Zenklub modules.
import { environment } from 'environments/environment';

@Injectable()
export class GlobalService {
	// Security data.
	public token: string;

	// Constructor method.
	constructor(private translate: TranslateService) {}

	// Get API (v2) address based on active environment.
	getApiAddress(): string {
		// Return current active address.
		return environment.url;
	}

	// Get a translated text.
	getTranslated(key: string, def: string): any {
		this.translate.get(key).subscribe((res: string) => {
			return res || def;
		});
	}

	// Get default user's picture.
	getDefaultUserPicture() {
		return '/assets/images/nophoto_blue_solid.png';
	}

	// Get IndexedDb database version.
	getDatabaseVersion(): number {
		// Get stored version (or default).
		const dbVersion = '11';
		// Return current version.
		return parseInt(dbVersion, 10);
	}

	// Check if is online.
	checkConnectivity(): boolean {
		return navigator.onLine;
	}

	// Check if is a mobile like device.
	isMobileDevice(): boolean {
		// Get window size.
		const innerWidth: number =
			document.documentElement.clientWidth || window.screen.width;
		return innerWidth < 800;
	}

	// Return public URLs (does not require logged in user).
	getPublicPages(): string[] {
		return ['conference', 'login', 'logoff', 'logout', 'update'];
	}

	// Return URLs without main header.
	getPagesWithoutHeader(): string[] {
		return [
			'adminlogin',
			'conference',
			'login',
			'logoff',
			'logout',
			'reasons',
			'session',
			'signup',
			'update',
		];
	}
}
